<header class="iss-portal-header" [class.iss-portal-header--expanded]="expanded">
  <div class="iss-portal-header-account iss-portal-header__account">
    <ng-content/>
  </div>
  <div class="iss-portal-header-name">
    {{ name }}
  </div>
  <div class="iss-portal-header-subtext" *ngIf="subtext">
    {{ subtext }}
  </div>
</header>
